import type { Track } from './track'
import type {
  ProviderWidgetProperties,
  ProviderLinkProperties,
} from '@core/analytics/objects/ProviderLink'
import { ProviderLinkClickout } from '@core/analytics/core-events/providerLink'

const WIDGET_TYPE_ATTR = 'data-widget-type'
const WIDGET_TITLE_ATTR = 'data-widget-title'
const TRACK_AUTO_ATTR = 'data-track-auto'

function getLinkData(anchor: HTMLAnchorElement): ProviderLinkProperties {
  const img = anchor.querySelector('img')
  if (img) return { type: 'image', label: img.src }

  const p = anchor.closest('p')
  if (p) return { type: 'text', label: anchor.text.trim() }

  return { type: 'button', label: anchor.text.trim() }
}

function getParentWidgetData(element: HTMLElement): ProviderWidgetProperties {
  const widgetSelector = `[${WIDGET_TYPE_ATTR}]`
  const widgetElement = element.closest(widgetSelector)
  const type = widgetElement?.getAttribute(WIDGET_TYPE_ATTR) ?? 'N/A'
  const title = widgetElement?.getAttribute(WIDGET_TITLE_ATTR) ?? 'N/A'

  return { type, title }
}

export function getSlugFromLink(link: string, redirectUrl: string) {
  // matches provider redirect urls: "go.monito.com/v2/slug" and "go.monito.com/slug"
  // https://regex101.com/r/yg1RyT/2
  const regexp = new RegExp(
    '^' + redirectUrl.replace(/\./g, '\\.') + '\\/(?:v[0-9]{1,2}\\/)?([\\w-]+)',
  )
  const href = link.match(regexp)
  return href?.[1]?.toLowerCase()
}

export function trackProviderClickout(redirectUrl: string, track: Track) {
  document.addEventListener(
    'click',
    ({ target }) => {
      const linkElement = target instanceof Element ? target.closest('a') : null
      if (linkElement?.href.includes(redirectUrl)) {
        const slug = getSlugFromLink(linkElement.href, redirectUrl)
        if (!slug) return

        storeProviderClickout(slug).catch(() => {
          // ignore
        })

        const { $inAppEvent } = useNuxtApp()
        $inAppEvent('af_provider_clickout', { af_provider_slug: slug })

        if (linkElement.getAttribute(TRACK_AUTO_ATTR) !== 'off') {
          const widget = getParentWidgetData(linkElement)
          const link = getLinkData(linkElement)
          track(ProviderLinkClickout(slug, widget, link)).catch(() => {
            // ignore
          })
        }
      }
    },
    true,
  )
}
